<template>
  <div class="content">

    <div v-if="!$store.state.bpo.inputs.rents.length">
      <div class="column">

        <div class="tile">
          <div class="tile is-parent is-vertical">

            <article class="tile is-child notification is-warning">
              <p class="subtitle">After you input the rents then a Summary Projection will be created</p>
            </article>

          </div>

        </div>
      </div>
    </div>

    <div
      class="columns"
      v-if="$store.state.bpo.inputs.rents.length"
    >

      <div class="column">

        <div class="tile">
          <div class="tile is-parent is-vertical">

            <article class="tile is-child notification">
              <p class="subtitle">Property Address</p>
              <p>{{ $store.state.property.address }}<br />{{ $store.state.property.city }}, {{ $store.state.property.state }} {{ $store.state.property.zip }}</p>
            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Scheduled Rents</p>

              <table>
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Scheduled Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.currentRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft | number(0) }}</td>
                  <td class="align-center">{{ line.currentPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.currentMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.currentAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalUnitCount_J19 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentRent_K19 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalSqft_L19 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentPricePerSqft_M19 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentMonthly_N19 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalCurrentAnnual_O19 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Proforma Rents</p>

              <table>
                <tr>
                  <td class="header">Type</td>
                  <td class="header align-center">#</td>
                  <td class="header align-center">Proforma Rent</td>
                  <td class="header align-center">Sqft</td>
                  <td class="header align-center">$/Sqft</td>
                  <td class="header align-center">Monthly $</td>
                  <td class="header align-center">Annually $</td>
                </tr>

                <tr
                  v-for="(line, index) in $store.state.bpo.outputs.rents"
                  v-bind:key="index"
                  class="row"
                >
                  <td>{{ line.type }}</td>
                  <td class="align-center">{{ line.unitCount }}</td>
                  <td class="align-center">{{ line.proformaRent | currency(0) }}</td>
                  <td class="align-center">{{ line.sqft }}</td>
                  <td class="align-center">{{ line.proformaPricePerSqft | currency(2) }}</td>
                  <td class="align-center">{{ line.proformaMonthly | currency(0) }}</td>
                  <td class="align-center">{{ line.proformaAnnual | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td class="footer align-center"></td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalUnitCount_J19 }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaRent_K37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalSqft_L19 | number(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaPricePerSqft_M37 | currency(2) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaMonthly_N37 | currency(0) }}</td>
                  <td class="footer align-center">{{ this.$store.state.bpo.outputs.totalProformaAnnual_O37 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Deal Terms</p>

              <table>

                <tr>
                  <td>Asking Price</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.askingPrice_E17 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.askingPricePerUnit_F17 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Offer Price</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.offerPrice_E18 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.offerPricePerUnit_F18 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Rehab - In Loan</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.rehabInLoan_E19 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.rehabInLoanPerUnit_F19 | currency(0) }} per unit</td>
                </tr>

                <tr>
                  <td>Total "In"</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.totalIn_E20 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Closing Cost</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.closingCost_E21 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.closingCostPercent_D21 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>Operating Capital</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.operatingCapital_E22 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Rehab - Not In Loan</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.rehabNotInLoan_E23 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Total Out Of Pocket</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.totalOutOfPocket_E24 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td># of Units</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.numberOfUnits_E26 }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Total "In" $/Unit</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.totalInPricePerUnit_E27 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Down Payment</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.downPayment_F28 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.downPaymentPercent_E28 | percent(0) }}</td>
                </tr>

                <tr>
                  <td>Loan Amount</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.loanAmount_E29 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Interest Rate</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.interestRatePercent_E30 | percent(2) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Years Amortization</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.termInYears_E31 }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Annual Debt Service</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.annualDebtService_E32 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>Total Rehab</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.totalRehab_E33 | currency(0) }}</td>
                  <td></td>
                </tr>

                <tr>
                  <td>% of Rehab to be Financed</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.percentOfRehabToBeFinanced_E34 | percent(0) }}</td>
                  <td></td>
                </tr>

              </table>

            </article>

            <article class="tile is-child notification">

              <p class="subtitle">Assumptions and Summary Projection</p>

              <table>

                <tr>
                  <td></td>
                  <td class="align-right column-header">{{ $store.state.bpo.outputs.actuals.label_E36 }}</td>
                  <td class="align-right column-header">{{ $store.state.bpo.outputs.brokers.label_F36 }}</td>
                  <td class="align-right column-header">Proforma</td>
                </tr>

                <tr>
                  <td>Economic Vacancy Rate</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.economicVacancyRate_K41 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.brokers.economicVacancyRate_K42 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.inputs.proformas.economicVacancyRate_K43 | percent(1) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Gross Rental Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.grossRentalIncome_E38 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.grossRentalIncome_F38 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.grossRentalIncome_G38 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Economic Vacancy</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.economicVacancy_E39 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.economicVacancy_F39 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.economicVacancy_G39 | currency(0) }}</td>
                </tr>

                <tr class="subtotal1">
                  <td>Net Rental Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netRentalIncome_E40 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netRentalIncome_F40 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netRentalIncome_G40 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Laundry</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.laundry_E42 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.laundry_F42 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.laundry_G42 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>RUBS</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.rubs | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.rubs | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.rubs | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Misc. Other Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.miscellaneousOtherIncome_E43 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.miscellaneousOtherIncome_F43 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.miscellaneousOtherIncome_G43 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Total Net Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.totalNetIncome_E45 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.totalNetIncome_F45 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.totalNetIncome_G45 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Expenses per Unit</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.expensesPerUnit_E47 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.expensesPerUnit_F47 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.expensesPerUnit_G47 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Expenses per Sqft</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.expensesPerSqft_E48 | currency(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.expensesPerSqft_F48 | currency(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.expensesPerSqft_G48 | currency(2) }}</td>
                </tr>

                <tr>
                  <td>Expenses as % of Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.expensesAsPercentOfIncome_E49 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.expensesAsPercentOfIncome_F49 | percent(1) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.expensesAsPercentOfIncome_G49 | percent(1) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Total Expenses</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.totalExpenses_E51 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.totalExpenses_F51 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.totalExpenses_G51 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>Net Operating Income</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netOperatingIncome_E53 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netOperatingIncome_F53 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netOperatingIncome_G53 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Mortgage Interest</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.mortgageInterest_E55 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.mortgageInterest_F55 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.mortgageInterest_G55 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Capital Reserves per Unit</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.capitalReservesPerUnit_E57 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.capitalReservesPerUnit_F57 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.capitalReservesPerUnit_G57 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Capital Reserves</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.capitalReserves_E58 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.capitalReserves_F58 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.capitalReserves_G58 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Pre-Tax Profit</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.preTaxProfit_E60 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.preTaxProfit_F60 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.preTaxProfit_G60 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Pre-Tax ROI</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.preTaxROI_E61 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.preTaxROI_F61 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.preTaxROI_G61 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Asset Management {{ $store.state.bpo.inputs.assetManagementPercent_D63 | percent(2)}}</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.assetManagement_F63 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.assetManagement_G63 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Principal Reduction</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.principalReduction_E64 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.principalReduction_F64 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.principalReduction_G64 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.debtService_E65 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.debtService_F65 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.debtService_G65 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Debt Service Coverage Ratio</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.debtServiceCoverageRatio_E66 | number(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.debtServiceCoverageRatio_F66 | number(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.debtServiceCoverageRatio_G66 | number(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net Cash Flow (Annual)</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netCashflowAnnual_E68 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netCashflowAnnual_F68 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netCashflowAnnual_G68 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal2">
                  <td>Net ROI (Cash-on-Cash)</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.netROICashOnCash_E70 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netROICashOnCash_F70 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netROICashOnCash_G70 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>Lead Investor Compensation {{ $store.state.bpo.inputs.leadInvestorCompensationPercent_D72 | percent(2) }}</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.leadInvestorCompensation_F72 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.leadInvestorCompensation_G72 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net to Passives</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netToPassives_F73 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netToPassives_G73 | currency(0) }}</td>
                </tr>

                <tr>
                  <td>Net ROI to Passives</td>
                  <td class="align-right"></td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.netROIToPassives_F74 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.netROIToPassives_G74 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>CAP RATE PROJECTION</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.capRateProjection_E76 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.capRateProjection_F76 | percent(2) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.capRateProjection_G76 | percent(2) }}</td>
                </tr>

                <tr>
                  <td>&nbsp;</td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>

                <tr class="subtotal3">
                  <td>SUMMARY PROJECTION</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.actuals.brokerPriceOpinionProjection_E78 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.brokers.brokerPriceOpinionProjection_F78 | currency(0) }}</td>
                  <td class="align-right">{{ $store.state.bpo.outputs.proformas.brokerPriceOpinionProjection_G78 | currency(0) }}</td>
                </tr>

              </table>

            </article>

            <article
              class="tile is-child notification"
              v-if="$store.state.bpo.inputs.notes_I45"
            >

              <p class="subtitle">Notes</p>

              <div>
                <vue-editor
                  style="background-color: #ffffff; height: auto;"
                  v-model="$store.state.bpo.inputs.notes_I45"
                  :editorOptions="editorSettings"
                ></vue-editor>
              </div>

            </article>

          </div>
        </div>

      </div>

    </div>

    <p class="disclaimer">DISCLAIMER: This represents an estimated sale price for this property. It is not the same as the opinion of value in an appraisal developed by a licensed appraiser under the Uniform Standards of Professional Appraisal Practice. LS Realty Advisors, Inc., and/or Lifestyles Realty, Inc., and/or Lifestyles Unlimited, Inc. have not verified the information and make no guarantee, warranty, or representation. This broker price opinion was either filled out by a Lifestyles representative or the potential buyer or other. Further investigation may be necessary as more information is made available. When more information is available the opinion may substantially change; the reader should be aware of the limited scope of this opinion.</p>

  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },

  data() {
    return {
      editorSettings: {
        modules: {
          toolbar: false
        }
      }
    };
  }
};
</script>

<style>
</style>
